import {styled} from 'styled-components';
import {Flex, Radio} from 'antd';
import type {RadioChangeEvent} from 'antd';
import {useDispatch, useSelector} from 'react-redux';
import {AppDispatch} from '../../../../config/store';
import {rKeeperSelect, setTableCase} from '../../../../entities/rKeeper';
import {FC} from 'react';
import {flexMixin, textMixin} from '../../../../styles/mixins';
import {colors} from '../../../../styles';
import {dataForSwitch} from '../../../../utils/const';

const TableHeaderRevenue: FC = () => {
    const {tableCase} = useSelector(rKeeperSelect);
    const dispatch = useDispatch<AppDispatch>();
    const onChange = (e: RadioChangeEvent) => {
        dispatch(setTableCase(e.target.value));
    };
    const {Group} = Radio;

    return (
        <TableHeaderWrapper>
            <TitleHeader>
                <p>{dataForSwitch[tableCase].text}</p>
            </TitleHeader>
            <StyledButtonWrapper>
                <Flex gap="small">
                    <Group onChange={onChange} size="middle">
                        <StyledRadioButton value={0} $active={tableCase === 0}>
                            Рестораны
                        </StyledRadioButton>
                        <StyledRadioButton value={1} $active={tableCase === 1}>
                            Официанты
                        </StyledRadioButton>
                    </Group>
                </Flex>
            </StyledButtonWrapper>
        </TableHeaderWrapper>
    );
};

export default TableHeaderRevenue;

const TableHeaderWrapper = styled.div`
    ${flexMixin('row', 'space-between', 'center')};
    background-color: #422795;
    padding: 20px 33px 20px 30px;
    border-radius: 8px 8px 0px 0px;

    @media (max-width: 768px) {
        flex-direction: column;
        gap: 16px;
        padding: 16px;
    }
`;

const TitleHeader = styled.div`
    ${textMixin({
        fontSize: '14px',
        fontWeight: 600,
    })};
    line-height: 120%;
    color: ${colors.cleanWhite};

    @media (max-width: 768px) {
        width: 100%;
        text-align: center;
    }
`;

const StyledButtonWrapper = styled.div`
    display: flex;
    flex-shrink: 0;

    .ant-radio-group {
        display: flex;
        flex-wrap: nowrap;
        white-space: nowrap;
    }
`;

const StyledRadioButton = styled(Radio.Button)<{$active: boolean}>`
    && {
        color: ${(props) => (props.$active ? colors.grey : '#A7A7A7')};
        border-color: ${(props) => (props.$active ? '#a7388e' : '#A7A7A7')};

        &:hover {
            color: ${colors.blackText};
            border-color: ${colors.gradEnd};
        }
    }
`;
